import React from "react";
import { makeStyles } from "@mui/styles";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import Lottie from "lottie-react";
import ChartLoader from "../../animations/ChartLoading.json";

const useStyles = makeStyles((theme) => ({
  noDataContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "80%",
    fontSize: theme.fontSizes.SMALL,
  },
  noDataIcon: {
    fontSize: "3.5rem",
    color: theme.palette.primary.main,
  },
}));

const NoData = ({ errorLabel }) => {
  const classes = useStyles();
  return (
    <div className={classes.noDataContainer}>
      {/* <Lottie animationData={ChartLoader} loop={true} /> */}
      <QueryStatsIcon className={classes.noDataIcon} />
      <div>{errorLabel}</div>
    </div>
  );
};

export default NoData;
